import { Link } from 'react-router-dom'
import { Compass } from 'lucide-react'
import { Button } from '../../shared/components/Button'

export function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-st-bg px-6 text-center">
      <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-st-lg bg-st-primary text-white">
        <Compass className="h-7 w-7" />
      </span>
      <h1 className="font-display text-3xl font-bold text-st-text">Lost the trail</h1>
      <p className="mt-2 max-w-sm text-sm text-st-muted">
        This page doesn’t exist. Let’s get you back to your trips.
      </p>
      <Link to="/" className="mt-5">
        <Button variant="accent">Back to trips</Button>
      </Link>
    </div>
  )
}
